<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "MyCustomerAccount",

  metaInfo() {
    return {
      title: this.$t("customerSP.title"),
      titleTemplate: (titleChunk) => {
        return titleChunk
          ? `${titleChunk} - ${this.$t("meta.titleTemplate")}`
          : this.$t("meta.titleTemplate");
      },
    };
  },

  extends: View,

  mixins: [
    LoadSections(["serviceprovider/sections/serviceprovider-customer-market"]),
  ],

  props: {
    id: {
      type: String,
      default: "procost",
    },
  },
};
</script>
